import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NavButton from './NavButton';
import Styles from './index.module.css';

export default function SignInNavBar() {
  const pages = {
    Home: '首頁',
    Offer: '投資介紹',
    Calculator: '報酬試算',
  };
  const history = useHistory();
  const location = useLocation();
  return (
    <div className={Styles.container}>
      {Object.keys(pages).map((page) => (
        <NavButton
          key={pages[page]}
          onClick={() => { history.push(`/${page}`); }}
          selected={location.pathname === `/${page}`}
        >
          {pages[page]}
        </NavButton>
      ))}
      <NavButton
        onClick={() => { window.open('https://www.hhgalaxy.com.tw/qa', '_blank'); }}
      >
        常見問題
      </NavButton>
    </div>
  );
}
